import authenticationService from '../service/authentication';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

class NotAuthenticated extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    user: PropTypes.object.isRequired
  };

  render () {
    if (!authenticationService.isAuthenticated) {
      return (
        <div className='not-authenticated'>{this.props.children}</div>
      );
    }

    return null;
  }
}

export default connect()(NotAuthenticated);



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/components/not-authenticated.js
 **/